/**
 * Home page services teaser — a curated subset of the full catalog
 * in src/constants/servicesCatalog.js (see the Services page for all 7).
 */
import { buildService } from "../../../constants/servicesCatalog";

const HOME_TEASER_KEYS = ["webDev", "mobileApps", "digitalProfile"];

export const getServices = (t) => HOME_TEASER_KEYS.map((key) => buildService(t, key));
